import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import new1Bg from "../../../assets/images/new1Bg.png";

// Imagem do Mockup
import imacImage from '../../../assets/images/imacNeo.png';
const HeroSection = () => {
  return (
    <div style={{
      backgroundImage: `url(${new1Bg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'left center',
      backgroundRepeat: 'no-repeat',
      minHeight: '95vh', 
      display: 'flex',
      alignItems: 'flex-end',
      position: 'relative',
      paddingTop: '80px', 
      overflow: 'hidden' 
    }}>
      {/* Overlay opcional para garantir a leitura sobre o bg */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1
      }}></div>

      <Container fluid className="px-4 px-xl-5 position-relative" style={{ zIndex: 2 }}>
        <Row className="align-items-center">
          {/* Coluna da Esquerda: Título Estiloso */}
          <Col lg={7} className="mb-5 mb-lg-0 text-white position-relative" style={{ zIndex: 10 }}>
            {/* Reflexos de margens para realinhar o texto mais pra baixo e alinhado ao layout */}
            <div className="pe-lg-4 position-relative" style={{ animation: 'fadeInLeft 1s ease-out', marginTop: '120px', marginLeft: 'clamp(0px, 4vw, 60px)', marginBottom: '40px' }}>
              
              {/* Texto de Fundo (Sombra Transparente Animada) */}
              <div 
                className="text-uppercase position-absolute" 
                style={{
                  fontSize: 'clamp(5rem, 12vw, 14rem)', 
                  fontWeight: 'bold', 
                  color: 'transparent',
                  WebkitTextStroke: '1px rgba(100, 180, 255, 0.25)', 
                  top: '-15%',
                  left: '0', 
                  transform: 'translateY(-50%)',
                  zIndex: -1,
                  whiteSpace: 'nowrap',
                  userSelect: 'none',
                  animation: 'floatingShadow 8s ease-in-out infinite alternate',
                  letterSpacing: '8px'
                }}
              >
                PISCINA
              </div>

              {/* Bloco Título Principal - deslocado isoladamente mais para cima (sem mexer na sombra acima) */}
              <div style={{ position: 'relative', top: '-60px', zIndex: 2 }}>
                <h1 className="mb-0 text-white" style={{ lineHeight: '1' }}>
                  <span className="d-block text-uppercase" style={{ fontSize: 'clamp(4rem, 8vw, 10rem)', letterSpacing: '-2px', fontWeight: 'bold', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                    PISCINA
                  </span>
                </h1>

                {/* Subtítulo com Faixa Vertical Neon */}
                <div className="d-flex mt-4">
                  <div 
                    style={{
                      width: '4px',
                      backgroundColor: '#00f3ff',
                      boxShadow: '0 0 8px #00f3ff, 0 0 15px rgba(0, 243, 255, 0.6)',
                      borderRadius: '2px',
                      marginRight: '18px',
                      flexShrink: 0
                    }}
                  ></div>
                  <p className="mb-0" style={{ 
                    color: '#e0e0e0',
                    fontSize: 'clamp(1.1rem, 1.5vw, 1.5rem)', 
                    fontWeight: '300', 
                    maxWidth: '800px', 
                    lineHeight: '1.5',
                    textShadow: '1px 1px 3px rgba(0,0,0,0.8)' 
                  }}>
                    O software de gestão definitivo, projetado exclusivamente para você elevar a operação da sua piscina ao mais alto padrão de profissionalismo.
                  </p>
                </div>
                
                {/* Chamada para Ação */}
                <div className="mt-5" style={{ marginLeft: '22px' }}>
                  <a href="#fale-conosco" 
                     className="btn text-uppercase fw-bold"
                     style={{
                       backgroundColor: 'rgba(0, 243, 255, 0.1)',
                       border: '1px solid #00f3ff',
                       color: '#00f3ff',
                       padding: '16px 40px',
                       fontSize: '1.1rem',
                       borderRadius: '12px',
                       letterSpacing: '1px',
                       transition: 'all 0.3s ease',
                       boxShadow: '0 0 15px rgba(0, 243, 255, 0.3), inset 0 0 10px rgba(0, 243, 255, 0.1)',
                       textDecoration: 'none',
                       display: 'inline-block'
                     }}
                     onMouseOver={(e) => {
                       e.target.style.backgroundColor = 'rgba(0, 243, 255, 0.2)';
                       e.target.style.boxShadow = '0 0 25px rgba(0, 243, 255, 0.6), inset 0 0 15px rgba(0, 243, 255, 0.3)';
                       e.target.style.transform = 'translateY(-2px)';
                     }}
                     onMouseOut={(e) => {
                       e.target.style.backgroundColor = 'rgba(0, 243, 255, 0.1)';
                       e.target.style.boxShadow = '0 0 15px rgba(0, 243, 255, 0.3), inset 0 0 10px rgba(0, 243, 255, 0.1)';
                       e.target.style.transform = 'translateY(0)';
                     }}
                  >
                    Fale Conosco
                  </a>
                </div>
              </div>
            </div>
            
            <style>
              {`
                @keyframes fadeInLeft {
                  from { transform: translateX(-40px); opacity: 0; }
                  to { transform: translateX(0); opacity: 1; }
                }
                @keyframes floatingShadow {
                  from { transform: translateY(-50%) translateX(0px); }
                  to { transform: translateY(-50%) translateX(-25px); }
                }
              `}
            </style>
          </Col>

          {/* Coluna da Direita: iMac Imagem (alinhado à direita) */}
          <Col lg={5} xl={5} className="text-end align-self-end">
            <div style={{
              margin: '0 0 0 auto', // Zera a margem que puxava para a esquerda
              top: '0px',           // Zera a elevação, forçando o iMac a encostar na margem inferior
              right: '-2vw',       // Joga ligeiramente para fora da direita
              maxWidth: '700px', // Reduzido de 850px
              width: '100%',
              position: 'relative',
              animation: 'fadeInRight 1s ease-out'
            }}>
              <img
                src={imacImage}
                alt="NeoApp no iMac"
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                  filter: 'drop-shadow(-20px 20px 30px rgba(0,0,0,0.3))'
                }}
              />

              {/* CSS Animations */}
              <style>
                {`
                  @keyframes fadeInRight {
                    from { transform: translateX(40px); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                  }
                `}
              </style>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
